import React from 'react';
import { Stack } from '@mui/material';

const HDButtonsRow = ({ leftButtons, rightButtons, justifyContent }) => {
  return (
    <Stack direction="row" spacing={2} justifyContent={justifyContent || "space-between"}>
      <Stack direction="row" spacing={1}>
        {leftButtons?.map((ButtonComponent, index) => (
        <React.Fragment key={index}>{ButtonComponent}</React.Fragment>
        ))}
      </Stack>
      <Stack direction="row" spacing={1}>
        {rightButtons?.map((ButtonComponent, index) => (
        <React.Fragment key={index}>{ButtonComponent}</React.Fragment>
        ))}
      </Stack>
    </Stack>
  );
};

export default HDButtonsRow;
